import React, { Component } from 'react'
import type { IntlShape } from 'react-intl'
import { injectIntl } from 'react-intl'
import { Layout, SigninSignup } from 'app/ecommerce/common'
import styled from 'styled-components'
import { media } from 'app/assets/styles'
import { colors } from 'shared/assets/styles'

const { lightMayo } = colors

type Props = {
    activeLeft: boolean,
    className?: string,
    fromUrl: string,
    fetchSigninPageData: () => void,
    fetchSignupPageData: () => void,
    intl: IntlShape
}

class SigninSignupRoute extends Component<Props> {
    componentDidMount(): void {
        this.props.fetchSigninPageData()
    }

    render() {
        const {
            activeLeft,
            fetchSigninPageData,
            fetchSignupPageData,
            fromUrl
        } = this.props
        return (
            <Layout
                background="plain"
                backgroundColor={lightMayo}
                border
                noFooter
                showLogoBK
                backEnabled
                backUrl={fromUrl}>
                <Main>
                    <SigninSignup
                        fromUrl={fromUrl}
                        activeLeft={activeLeft}
                        onLeftFocus={fetchSignupPageData}
                        onRightFocus={fetchSigninPageData}
                        fromEcommerce
                    />
                </Main>
            </Layout>
        )
    }
}

const Main = styled.section`
    padding: 25px 0;
    ${media.medium`
        padding: 50px 0;
    `};
    margin-top: 50px;
    ${media.medium`
         margin-top: 50px;
      `}
`

export const SigninSignupRouteComponent = injectIntl(SigninSignupRoute)
